// extracted by mini-css-extract-plugin
export default {"dropdownContentHeader":"dropdownHeader_dropdownContentHeader__U-Sqm","closeButton":"dropdownHeader_closeButton__qwkSD"};